import { render, staticRenderFns } from "./ResidentialDetails.vue?vue&type=template&id=0dea8b04&"
import script from "./ResidentialDetails.vue?vue&type=script&lang=js&"
export * from "./ResidentialDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports